import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { showMoreOptionsDialog } from '../../actions/popup';

type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = DispatchProps;

function MoreOptions(props: Props) {
  return (
    <div>
      <Tooltip disableInteractive disableFocusListener id="more-options-tooltip" title="More Options">
        <IconButton onClick={props.showMoreOptionsDialog} aria-label="More Options" sx={{ borderRadius: 0 }}>
          <MoreHorizIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
}

const actionCreators = {
  showMoreOptionsDialog,
};

export default connect(null, actionCreators)(MoreOptions);
